export default "__VITE_ASSET__CIFC0fyz__"